import{gql as i}from"@apollo/client";const e=i`
  query getPinnedGeladaProjects($organisationKey: String!, $isFilteringActive: Boolean = false) {
    project {
      organisationProjects(organisationKey: $organisationKey, isFilteringFavourite: true, isFilteringActive: $isFilteringActive) {
        totalCount
        edges {
          cursor
          node {
            logo {
              presignedUrl
            }
            id
            name
            projectAdministrators {
              firstname
              lastname
            }
            isFavourite
          }
        }
      }
    }
  }
`;export{e as GET_PINNED_PROJECTS};
//# sourceMappingURL=useGetGeladaPinnedProjects.graphql.js.map
